import { render } from "./EmailOnboardingProvider.vue?vue&type=template&id=63aa744a&scoped=true"
import script from "./EmailOnboardingProvider.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingProvider.vue?vue&type=script&lang=js"

import "./EmailOnboardingProvider.vue?vue&type=style&index=0&id=63aa744a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63aa744a"]])

export default __exports__